import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { GET_CLINIC_PROVIDER_OPTIONS } from '../../clinic/gql/Query';
import clientGraphql from '../../../common/apollo-graphql';
import { useQuery } from '@apollo/client';
import { HookFormSelect } from '../../common/components';

export default function ProviderDropdownHookFormSelect({ prefix, control, errors, schema, placeholder, label, variant = 'outlined', clinicId }) {
  const [options, setOptions] = useState([]);

  const { data } = useQuery(GET_CLINIC_PROVIDER_OPTIONS, {
    client: clientGraphql,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: clinicId ? { id: clinicId } : null,
    skip: !clinicId,
  });

  useEffect(() => {
    if (data?.clinic?.providers?.length > 0) {
      setOptions(
        data.clinic.providers.map((item) => {
          return {
            value: item.id,
            label: item.display_name,
          };
        })
      );
    }

    return () => {
      setOptions([]);
    };
  }, [data, schema]);

  return (
    <HookFormSelect
      id={schema}
      name={schema}
      schema={schema}
      placeholder={placeholder}
      label={label}
      prefix={prefix}
      control={control}
      errors={errors}
      variant={variant}
      type="select"
      select
      fullWidth
    >
      {
        options.map((option) => (
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))
      }
    </HookFormSelect>
  );
}